module.exports = __webpack_public_path__ + "static/media/14.84171ae0.jpeg";